
import React from 'react';
import {css} from 'emotion';
import {useEffect} from 'react';
import {useStateAtom} from '../../../utilities/React/UseStateAtom.js';

export const FormEditBlockFieldMetadata = function (props) {

  const blockMetadata = useStateAtom([]);

  useEffect(() => {
    const newBlockMetadata = [
      ...Object.entries(props.block()?.metadata ?? {}).map(e => ({key: e[0], value: e[1]})).filter(e => !!e.key),
      {key: '', value: ''},
    ];
    if (JSON.stringify(blockMetadata()) == JSON.stringify(newBlockMetadata))
      return;
    blockMetadata(newBlockMetadata);
  }, [JSON.stringify(props.block())]);

  useEffect(() => {
    props.block({
      ...props.block(),
      metadata: Object.fromEntries(blockMetadata().filter(e => !!e.key).map(e => [e.key, e.value])),
    });
  }, [JSON.stringify(blockMetadata())]);

  if (!props.block()?.component || props.block()?.component == 'Group' || props.block()?.component == 'HTML')
    return (<></>);

  return (<>
    <div
      className={css`
        padding: 8px;
        border-style: solid;
        border-width: 1px;
        border-color: #d1d5db;
      `}
    >
      Metadata
      {blockMetadata().map((metadataEntry, metadataEntryIndex) => (<>
        <div
          key={metadataEntryIndex}
          className={css`
            display: flex;
            gap: 8px;
            margin-top: 8px;
          `}
        >
          <div
            className={css`
              flex: none;
              width: 256px;
              display: grid;
              place-content: stretch;
              place-items: center;
            `}
          >
            <input
              className={css`
                width: 100%;
              `}
              type="text"
              value={String(metadataEntry.key)}
              onChange={(e) => {
                blockMetadata([
                  ...blockMetadata().slice(0, metadataEntryIndex),
                  {
                    ...blockMetadata()[metadataEntryIndex],
                    key: e.target.value,
                  },
                  ...blockMetadata().slice(metadataEntryIndex + 1),
                ]);
              }}
            />
          </div>
          <div
            className={css`
              flex: 1 1 0%;
              display: grid;
              place-content: stretch;
              place-items: center;
            `}
          >
            <input
              className={css`
                width: 100%;
              `}
              type="text"
              value={metadataEntry.value}
              onChange={(e) => {
                blockMetadata([
                  ...blockMetadata().slice(0, metadataEntryIndex),
                  {
                    ...blockMetadata()[metadataEntryIndex],
                    value: e.target.value,
                  },
                  ...blockMetadata().slice(metadataEntryIndex + 1),
                ]);
              }}
            />
          </div>
        </div>
      </>))}
    </div>
  </>);

};
